<script setup>
const props = defineProps({
  location: Object,
  navLabels: Object,
  showPromoBanner: Boolean  
})

const sticky = ref(false)
const observer = ref({});
const { urlRegisterFunction } = useUtils();

const observeHeroSection = () => {
  observer.value = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      sticky.value = !entry.isIntersecting;
    })
  });
  const heroSection = document.getElementById('hero-section');
  
  if (heroSection) {
    observer.value.observe(heroSection);
  }
  else {
    sticky.value = true;
  }
}

const observeSections = () => {

}

onMounted(() => {
  observeHeroSection();  
  document.addEventListener('scroll', () => {
    const documentHeight = document.body.scrollHeight;
    const currentScroll = window.scrollY + window.innerHeight;
    // When the user is [modifier]px from the bottom, fire the event.
    let modifier = 10; 
    if (currentScroll + modifier > documentHeight) {
      const footer = document.getElementById('footer');
      footer.classList.add('bottom-sticky-bar')
    }
    else {
      footer.classList.remove('bottom-sticky-bar')
    }
  })
});

onUpdated(() => {
  observeHeroSection();
});

const classes = computed(() => {
  return {    
    'sticky': sticky.value,
    'promo-banner': props.showPromoBanner === true
  }
})

const footerClasses = computed(() => {
  return {
    'w-100': true,
    'd-none': !sticky.value,
    'd-block': sticky.value,    
    'sticky': sticky.value
  }
})

const ctaClasses = computed(() => {
  return {    
    'd-xs-none': sticky.value
  }
})

const emit = defineEmits(['onSignUpClick'])

// const onGetMoreInfo = () => {
//   emit('onGetMoreInfoClick');
// }

const onSignUp = () => {
  emit('onSignUpClick');
}

// Creating the sub menu items
const menuItems = ref([]);
if (props.location.overview.length > 0) {
  menuItems.value.push({
    id: 'overview',
    title: props.navLabels.dynamicZone1,
    active: true
  });
}
menuItems.value.push({
  id: 'campusLife',
  title: props.navLabels.dynamicZone2,
  active: false
});
if (props.location.campusLife.length > 0) {
  
}
if (props.location.instructors.length > 0) {
  menuItems.value.push({
    id: 'instructors',
    title: props.navLabels.dynamicZone3,
    active: false
  });
}
if (props.location.faqs.length > 0) {
  menuItems.value.push({
    id: 'faqs',
    title: props.navLabels.dynamicZone4,
    active: false
  });
}

const scrollTop = () => {
  return window.pageYOffset || document.documentElement.scrollTop;
}

const handleState = (item) => {
  for (let i = 0; i < menuItems.value.length; i++) {
    if (menuItems.value[i].id === item.id) {
      menuItems.value[i].active = true;
    }
    else {
      menuItems.value[i].active = false;
    }
  }

  // Scroll to element
  const offset = document.getElementById(item.id).offsetTop;
  const stickySubnavOffset = !sticky.value ? 60 : 0;
  const deviceOffset = screen.width >= 992 ? 80 : 0;
  const scrollTopTo = offset - 70 - stickySubnavOffset - deviceOffset;  
  window.scrollTo({
    top: scrollTopTo,
    behavior: 'smooth',
  });
}

</script>

<template>
  <div class="w-100 p-3 pb-0 pt-0 pt-lg-2 container-lg justify-content-center" :class="classes" id="location-sub-menu">
    <nav class="nav nav-pills flex-row  container-lg justify-content-between" role="navigation" id="location-navbar"> 
      <a v-for="item in menuItems" class="flex-sm-fill text-sm-center nav-link d-flex align-items-center text-center pb-0 pt-0" :class="item.active ? 'active' : ''" :href="`#${item.id}`" @click.prevent="handleState(item)">
        <span class="w-100 pb-0 pb-lg-2 pb-md-1">{{ item.title }}</span>
      </a>
      <a class="flex-sm-fill text-sm-center nav-link flex-grow-0 d-md-block mb-0 mb-md-2 pb-md-2 btn-wrapper" :class="ctaClasses" data-bs-toggle="modal" data-bs-target="#get-more-info" v-if="props.location.pulseLocation.status.typeId == 1">
        <button class="btn btn-outline-secondary display" v-if="sticky">{{ navLabels.secondaryCTA }}</button>
        <span v-else>{{ navLabels.secondaryCTA }}</span>
      </a>
      <a class="flex-sm-fill text-sm-center nav-link flex-grow-0 d-none d-md-block mb-0 mb-md-2 pb-md-2 btn-wrapper" :class="ctaClasses" @click.prevent="onSignUp" v-if="location.pulseLocation.status.typeId == 1">
        <button class="btn display btn-id-primary" v-if="sticky">{{ navLabels.primaryCTA }}</button>
        <span v-else>{{ navLabels.primaryCTA }}</span>
      </a>
      <a class="flex-sm-fill text-sm-center nav-link flex-grow-0 d-block d-md-none mb-0 mb-md-2 pb-md-2 btn-wrapper" :class="ctaClasses" :href="urlRegisterFunction(`?lid=${location.pulseId}`, true)" v-if="location.pulseLocation.status.typeId == 1">
        <button class="btn display btn-id-primary" v-if="sticky">{{ navLabels.primaryCTA }}</button>
        <span v-else>{{ navLabels.primaryCTA }}</span>
      </a>
    </nav>
  </div>
  <div :class="footerClasses" class="d-xs-block d-md-none" id="sub-menu-footer" v-if="location.pulseLocation.status.typeId == 1">
    <nav class="nav nav-pills d-flex flex-row justify-content-center" role="navigation">      
      <a class="pe-0 flex-sm-fill text-sm-center nav-link pb-3 cta " data-bs-toggle="modal" data-bs-target="#get-more-info">
        <button class="btn btn-outline-secondary display" v-if="sticky">{{ navLabels.secondaryCTA }}</button>
        <span v-else>{{ navLabels.secondaryCTA }}</span>       
      </a>
      <a class="flex-sm-fill text-sm-center nav-link pb-3 cta" :href="urlRegisterFunction(`?lid=${location.pulseId}`, true)">
        <button class="btn display btn-id-primary" v-if="sticky">{{ navLabels.primaryCTA }}</button>
        <span v-else>{{ navLabels.primaryCTA }}</span>
      </a>
    </nav>
  </div>
</template>

<style lang="scss" >

#footer.bottom-sticky-bar  {
  margin-bottom: 60px;
}

#location-sub-menu {  
  background-color: $color-accent;
  border-radius: 0px;
  overflow-x: auto;


  @include media-breakpoint-down(lg) {
    max-width: 100%;
    border-radius: 0px;
  }

  .btn-wrapper {
    cursor: pointer;
    &:hover {
      font-weight: 600;
    }
  }

  &:not(.sticky) .nav-pills {
    padding-top: 13px;
    .nav-link:not(.btn-wrapper) {
      padding-bottom: 10px !important;
    }
    .btn-wrapper {
      padding-bottom: 17px !important;
    }
  }

  &.sticky {    
    position: fixed;
    top: 60px;
    box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
    z-index: 1003;
    border-radius: 0px;

    .btn-wrapper {
      margin-bottom: 0px !important;
    }

    &.promo-banner {
      top: 90px;

      @include media-breakpoint-up(lg) {
      top: 95px;
      }
    }

    @include media-breakpoint-up(lg) {
      top: 60px;
      z-index: 999;
      box-shadow: none;
      max-width: 100%;
    }

    .nav.nav-pills {
      min-height: 70px;
    }

  }

  nav {
    width: max-content;
    .nav-link {      
      &:not(.cta) {
        color: $color-primary;
        &.active {
          border-bottom: 4px solid $color-primary;
          font-weight: 600;
          background-color: transparent;
          border-radius: 0px;
        }
      }      
    }
    @include media-breakpoint-up(lg) {
      width: 100%;
    }
  }

  @include media-breakpoint-up(md) {
    border-radius: 12px;
    overflow: hidden;    
  }
}

#sub-menu-footer {  
  @include media-breakpoint-down(xs) {
    &.sticky {
      position: fixed;
      bottom: 0px;
      box-shadow: 0 -3px 6px 0 rgba(0, 0, 0, 0.16);
      background-color: $color-secondary;
      z-index: 1003;
    }
  }
}
</style>